/* eslint-disable */
// @ts-nocheck
/**
 * RTM Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export const VolumeAggregationDimension = {
  Specialisation: 'SPECIALISATION',
  Queue: 'QUEUE',
  TicketConfiguration: 'TICKET_CONFIGURATION',
  RequiredSkill: 'REQUIRED_SKILL',
  Country: 'COUNTRY',
  Language: 'LANGUAGE',
  PricingPlan: 'PRICING_PLAN',
  OperatingSystem: 'OPERATING_SYSTEM',
  Application: 'APPLICATION',
  ApplicationVersion: 'APPLICATION_VERSION',
  OperatingSystemVersion: 'OPERATING_SYSTEM_VERSION',
  UserProblemProblem: 'USER_PROBLEM_PROBLEM',
  UserProblemFeature: 'USER_PROBLEM_FEATURE',
} as const

export type VolumeAggregationDimension =
  (typeof VolumeAggregationDimension)[keyof typeof VolumeAggregationDimension]
